<script>
  import MenuItem from './MenuItem.svelte';
  import { slide } from 'svelte/transition';
  import { cubicInOut } from 'svelte/easing';
  import { createEventDispatcher, onMount } from 'svelte';
  import { LmsUtils } from '../utils/LmsUtils';
  import {External, M} from "../../external";

  export let selectedGroup, selectedPage, circleDetails, position = 'right', menuSize = 'compact';

  let dispatch = createEventDispatcher();
  let trackedPages = 0;

  let onItemClick = (page) => {
    dispatch('itemclick', { page: page });
  };

  let onOptions = (event, page) => {
    dispatch('options', {
      target: event.detail.target,
      page: page
    });
  };

  let onSorted = () => {
    selectedGroup.pages = selectedGroup.pages;
  }

  $: trackedPages = selectedGroup.pages.filter(page => page.settings?.trackContentCompletion).length;
</script>

<div class="circle-group-side-navigation flex-none custom-scroll"
     class:icons-with-border={circleDetails.circle.styling.sidebar.iconStyling.hasBorder}
     transition:slide={{ axis:"x", duration:300, easing: cubicInOut }}>
  <div class="circle-group-side-navigation-inner flex align-center flex-col">
    <div class="circle-page-item col20 f-left flex flex-col">
      <h4 class="circle-item-name circle-group-name flex align-center col20 f-left">
        <span>{selectedGroup.pageGroup.name}</span>
      </h4>

      {#if trackedPages > 0}
        <div class="progress-tracker col20 f-left mt-10 mb-10">
          <p class="col20 f-left inner-circle-desc t-left mb-5">0/{trackedPages} {M.COMPLETED}</p>
          <div class="progress-bar">
            <div class="success-bar primaryColor-bg2"></div>
          </div>
        </div>
      {/if}

    </div>
    <div class="circle-group-navigation col20 f-left" use:LmsUtils.setupMenuSortable={[circleDetails.circle, selectedGroup.pages, onSorted]}>

      {#each selectedGroup.pages as page, pageIdx (page)}
        {#key page}
          <MenuItem circleDetails={circleDetails} index={LmsUtils.getMenuItemNumber(page, selectedGroup.pages)} item={page} group={selectedGroup} on:click={() => onItemClick(page)}
                    active={page.id === selectedPage?.id}
                    {menuSize}
                    on:options={(event) => onOptions(event, page)} />
        {/key}
      {/each}

      <a on:click={() => dispatch('addpage')} class="f-left with-icon small-button blue circle-effect">
        {M.ADD_PAGE}
      </a>
    </div>
  </div>
</div>
